import { BackgroundImage, Center, Paper, Stack, Title } from '@mantine/core';

import BgImage from '@assets/images/bg.png';
import { Logo } from '@components';
import { useSettings } from '@hooks/useSettings';

export const AuthLayout = (props) => {
  const { children, title } = props;
  const { data: settings } = useSettings();

  const badgeDetails = settings?.isForwarder ? { badge: 'Customs Trade', badgeColor: '#ECCC38' } : { badge: 'Customs Clear', badgeColor: '#C0E5C9' };

  return (
    <BackgroundImage src={BgImage} radius={0} mih={'100vh'}>
      <Center mih={'100vh'}>
        <Paper radius="lg" shadow="xl" p={50} withBorder w="fit-content" miw={400} bg={'rgba(255, 255, 255, 0.85)'} style={{ backdropFilter: 'blur(5px)' }}>
          <Logo badge={badgeDetails.badge} badgeColor={badgeDetails.badgeColor} data-pw="login-logo-img" />
          <Stack mb={20} justify="flex-start" gap="md">
            {title && (
              <Title data-pw="login-title-h2" order={3} ta="center">
                {title}
              </Title>
            )}
          </Stack>
          {children}
        </Paper>
      </Center>
    </BackgroundImage>
  );
};
